import React from "react";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { Loading, PreviewModal } from "../components";
import { ApiHelper, DateHelper, EnvironmentHelper, FeedInterface, MessageHelper, MessageInterface } from "../helpers";
import { ManageFeed } from "./components";

export const FeedPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [feed, setFeed] = React.useState<FeedInterface>(null);
  const [messages, setMessages] = React.useState<MessageInterface[]>(null);
  const [previewId, setPreviewId] = React.useState(0);

  const init = () => {
    ApiHelper.get<FeedInterface>("/feeds/" + id).then((data) => { setFeed(data); });
    ApiHelper.get<MessageInterface[]>("/feeds/" + id + "/messages").then((data) => { setMessages(data || []); });
  }

  React.useEffect(init, [id])


  const getPreviewModal = () => {
    if (previewId > 0) return <PreviewModal messageId={previewId} onClose={() => { setPreviewId(0) }} />
  }

  const getSamples = () => {
    if (!messages) return <Loading />
    else {
      const result: React.ReactElement[] = [];
      let idx = 0;
      messages?.forEach(m => {
        const messageId = m.id;
        const thumbPath = MessageHelper.getThumbnailPath(m);
        result.push(<Col key={"preview" + idx} sm={6} md={4} xl={3}>
          <a href="about:blank" onClick={(e) => { e.preventDefault(); setPreviewId(messageId) }}>
            <img src={thumbPath} alt="thumbnail" />
            <span>{m.name}</span>
          </a>
        </Col >);
        idx++;
      });
      if (messages.length > 0) return (<>
        <hr />
        <h2>Included Messages</h2>
        <div id="designerList" className="row condensed">{result}</div>
      </>);

    }

  }

  if (!feed) return <Loading />
  else {
    const thumbPath = EnvironmentHelper.ContentRoot + "/feeds/" + feed.id + "/thumb.png?modified=" + DateHelper.convertToDate(feed.lastModified || new Date()).getTime();
    return (
      <div className="page-container">
        <div className="page-header">
          <h1><i className="fas fa-satellite-dish"></i> {feed.name}</h1>
        </div>
        <Row>
          <Col lg={8}>
            <Row>
              <Col sm={4}>
                <img src={thumbPath} alt="thumbnail" className="img-fluid" />
              </Col>
              <Col sm={8}>
                <div dangerouslySetInnerHTML={{ __html: feed.description }}></div>
              </Col>
            </Row>
          </Col>
          <Col lg={4}>
            <ManageFeed feed={feed} />
          </Col>
        </Row >

        {getSamples()}
        {getPreviewModal()}
      </div>
    );
  }
};